export enum LocalStorageNames {
  DashboardCalendar = 'dashboard-calendar-cache',
  CurrentUser = 'currentUser',
  EstimatePublished = 'estimate-published'
}
